
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Créer un blog d’entreprise efficace : guide et bonnes pratiques",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les étapes clés pour créer un blog d'entreprise qui attire, engage vos lecteurs et soutient vos objectifs de visibilité et de croissance en ligne.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment créer un blog d’entreprise efficace ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "S’il existe des blogs personnels, on compte également de nombreux blogs d’entreprise. Même des géants comme Orange, Conforama et Motorola ont le leur.",
        },
      ],
    };
  },
};
